import { Stack } from '@mui/material';
import { AppLogoLoader } from './components/AppLogoLoader';

export default function SplashScreen() {
  return (
    <Stack
      sx={{
        flex: 1,
        background: 'white',
        justifyContent: 'center',
        alignItems: 'center',
        height: '100vh',
      }}>
      <AppLogoLoader />
    </Stack>
  );
}
